import type {
  LegacyOrgUnitsResponse,
  OrgUnitDto,
} from "shared-ui/src/features/storefront-feature";
import { OrgUnitNavHeaderDto, StorefrontClient } from "@lib/ShiOneClient";
import { useApi } from "@utils/useApi";
import { useQuery } from "@tanstack/react-query";
import ms from "ms";
import {
  STOREFRONTS_LEGACY_ORG_UNITS_QUERY_KEY
} from "@features/storefronts-feature/utils/constants";
import { useClaims } from "../../../../../auth/ClaimsProvider";

function mapNavHeaderToOrgUnit(header: OrgUnitNavHeaderDto): OrgUnitDto {
  return {
    orgUnitId: header.orgUnitId,
    crmAccountId: header.crmAccountId ?? null,
    axAccountNumber: header.axAccountNumber ?? null,
    orgUnitName: header.orgUnitName ?? null,
    displayName: header.displayName ?? null,
    customCatalogName: null,
    customCatalogId: null,
    compositeCatalogId: null,
    parentOrgUnitId: null,
  };
}

export default function useGetLegacyOrgUnits() {
  const { getClaimValue } = useClaims();
  const api = useApi(StorefrontClient);

  const crmAccountId = getClaimValue("crmAccountId");

  const getLegacyOrgUnits = async(): Promise<LegacyOrgUnitsResponse> => {
    const headers = await api.getOrgUnitNavHeadersForCurrentUserAccount();
    return { orgUnits: headers.map(mapNavHeaderToOrgUnit) };
  };

  return useQuery<LegacyOrgUnitsResponse, Error>({
    queryKey: [STOREFRONTS_LEGACY_ORG_UNITS_QUERY_KEY, crmAccountId],
    queryFn: getLegacyOrgUnits,
    staleTime: ms("10m"),
  });
}

